<script>
	import { createEventDispatcher } from "svelte";
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";
	import CustomSearch from "../../../../components/CustomSearch/CustomSearch.svelte";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { fetchCancelReasons } from "src/services/lookupCache";
	import { cachedCancelReasons } from "src/store/store";
	import { formatErrorMessage } from "src/utils/misc";

	export let isOpen = false;
	export let isSubmitting = false;
	// Error from cancelling the issue, shown in the same banner.
	export let submitError = "";
	export let toggle = () => {};

	const dispatch = createEventDispatcher();

	let cancelReason = null;
	let isLoadingReasons = false;
	let errorText = "";
	let wasOpen = false;

	$: cancelReasonOptions = ($cachedCancelReasons ?? []).map((reason) => ({
		value: reason.code,
		label: reason.label,
	}));

	async function loadReasons() {
		isLoadingReasons = true;
		errorText = "";
		try {
			await fetchCancelReasons();
		} catch (error) {
			console.error(error);
			errorText =
				formatErrorMessage(error) || "Couldn't load cancel reasons.";
		} finally {
			isLoadingReasons = false;
		}
	}

	// Reopening the modal retries a failed load.
	$: if (isOpen && !wasOpen) {
		wasOpen = true;
		cancelReason = null;
		loadReasons();
	}
	$: if (!isOpen) {
		wasOpen = false;
	}

	function handleConfirm() {
		if (!cancelReason || isSubmitting) return;
		dispatch("confirm", { reasonCode: cancelReason.value });
	}

	$: placeholder = isLoadingReasons
		? "Loading cancel reasons..."
		: !errorText && $cachedCancelReasons && !cancelReasonOptions.length
			? "No cancel reasons available"
			: "Search cancel reason";
	$: isConfirmDisabled = !cancelReason || isSubmitting;
</script>

<Modal {isOpen} {toggle} centered>
	<ModalHeader>Cancel this issue</ModalHeader>
	<ModalBody>
		<ErrorMessageHandler message={submitError || errorText} />
		<p class="cancel-reason-label">Reason for cancelling issue*</p>
		<CustomSearch
			label="Reason for cancelling issue"
			{placeholder}
			containerClasses="search-icon"
			bind:value={cancelReason}
			items={cancelReasonOptions}
		/>
	</ModalBody>
	<ModalFooter>
		<Button class="themeButton backButton px-4" on:click={toggle}>
			Cancel
		</Button>
		<Button
			class="themeButton primary px-4"
			disabled={isConfirmDisabled}
			on:click={handleConfirm}
		>
			Confirm
		</Button>
	</ModalFooter>
</Modal>

<style>
	.cancel-reason-label {
		margin-bottom: 8px;
	}
</style>
